import { appConstants } from '../../../constants'

const initialState = {
  dataEvent: [],
  loading: false,
  error: null
};

export const reducerEvent = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.GET_EVENT_SUCCESS :
      return {
        ...state,
        loading: false,
        error: null,
        dataEvent: [...action.payload.events]
      };
    case appConstants.INIT_DATA :
      return {
        ...state,
        loading: !state.loading
      }
    default:
      return state
  }
}
